<script>
import { getFirstComponentChild } from '@/lib/utils/vue'

export default {
  functional: true,
  props: {
    componentName: String
  },
  render (createElement, { props, data, children }) {
    if (props.componentName && children?.length) {
      const firstNode = getFirstComponentChild(children)
      if (firstNode?.componentOptions) {
        firstNode.componentOptions.tag = props.componentName
      }
    }
    return children
  }
}
</script>
